import { create } from "zustand";
import { persist } from "zustand/middleware";
import { registerReset } from "./resetStore";

interface ChannelState {
  channel: "WEBBOT" | "WHATSAPP";
  setChannel: (channel: "WEBBOT" | "WHATSAPP") => void;
}

const initialState = {
  channel: "WEBBOT" as const,
};

export const useChannelStore = create<ChannelState>()(
  persist(
    (set) => ({
      ...initialState,
      setChannel: (channel) => set({ channel }),
    }),
    {
      name: "channel-storage",
    }
  )
);

registerReset(() => useChannelStore.setState(initialState));
